"use strict";
/*
 * A utility that takes both top-level 'exceptional' GraphQL errors (as per the
 * shape returned by https://graphql-ruby.org/) and GraphQL userErrors, and transforms
 * them into a sane structure.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasErrors = exports.normalizeErrors = void 0;

var tslib_1 = require("tslib");

var emptyErrors = {
  fields: {},
  general: []
};

var normalizeErrors = function normalizeErrors(result, error, locales) {
  if (error) {
    return processTopLevelErrors(error, {
      scalarMessage: locales.errors.scalar,
      generalMessages: locales.errors.general,
      fields: locales.fields
    });
  }

  if (result === null || result === void 0 ? void 0 : result.userErrors) {
    return processModelErrors(result.userErrors, locales);
  }

  return {
    fields: {},
    general: []
  };
};

exports.normalizeErrors = normalizeErrors;

var processTopLevelErrors = function processTopLevelErrors(error, locales) {
  var _a;

  if ((_a = error.graphQLErrors) === null || _a === void 0 ? void 0 : _a.length) return processScalarErrors(error.graphQLErrors[0], locales);

  if (error.networkError) {
    return processNetworkError(locales.generalMessages.network);
  }

  return emptyErrors;
};

var processNetworkError = function processNetworkError(networkErrorMessage) {
  return {
    fields: {},
    general: [networkErrorMessage]
  };
};

var processScalarErrors = function processScalarErrors(error, locales) {
  if (!error.extensions || !Array.isArray(error.extensions.problems)) {
    return emptyErrors;
  }

  return error.extensions.problems.reduce(function (acc, curr) {
    var _a;

    var fieldName = curr.path[curr.path.length - 1];
    var localeFieldName = locales.fields[fieldName];
    var message = "".concat(localeFieldName, " ").concat(locales.scalarMessage);
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, acc), {
      fields: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, acc.fields), (_a = {}, _a[fieldName] = message, _a))
    });
  }, emptyErrors);
};

var processModelErrors = function processModelErrors(userErrors, locales) {
  return userErrors.reduce(function (acc, curr) {
    var _a;

    var isFieldSpecificError = curr.path && curr.path.length > 0;
    var errorCode = curr.code;

    if (isFieldSpecificError) {
      var fieldName = curr.path[curr.path.length - 1];
      var localeFieldName = locales.fields[fieldName];
      var message = "".concat(localeFieldName, " ").concat(locales.errors.model[errorCode]);
      return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, acc), {
        fields: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, acc.fields), (_a = {}, _a[fieldName] = message, _a))
      });
    }

    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, acc), {
      general: (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], acc.general, true), [locales.errors.model[errorCode]], false)
    });
  }, {
    fields: {},
    general: []
  });
};

var hasErrors = function hasErrors(response) {
  return Object.keys(response.fields).length > 0 || response.general.length > 0;
};

exports.hasErrors = hasErrors;